import { render, staticRenderFns } from "./QmpBottom.vue?vue&type=template&id=28fcae33&scoped=true&"
import script from "./QmpBottom.vue?vue&type=script&lang=js&"
export * from "./QmpBottom.vue?vue&type=script&lang=js&"
import style0 from "./QmpBottom.vue?vue&type=style&index=0&id=28fcae33&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fcae33",
  null
  
)

export default component.exports